import useRepeatableMetaData from '@v4/hooks/useRepeatableMetaData'
import useFieldFocus from '@v4/hooks/useFieldFocus'
import useStyles from './Item.styled'

export const useItem = props => {
	const { group, index, itemKey, columnsNumber, className } = props
	const metaData = useRepeatableMetaData({ group, index })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.itemImage, index, itemKey })
	const classes = useStyles(props)

	return [
		{
			classes,
			columnsNumber,
			imageData: metaData.itemImage,
			className,
			itemKey,
		},
		{
			handleImageClick,
		},
	]
}
